// "What was this for?": an optional note on a purchase (migration 0039, transactions.note). Typed by
// the person only; the parser, auto-log, bills, merges and Done never write it. It crosses to a
// partner only as a split request's note, when a split is sent (never for an unsplit purchase).
// Every line of its copy and its rules are here.

export const NOTE_LABEL = 'What was this for?';
export const NOTE_MAX = 80;
/** Chips under the field: the household's most recent distinct notes for the same merchant. */
export const NOTE_SUGGESTIONS = 4;

/** Trimmed; empty is null (no note). */
export const cleanNote = (s: string | null | undefined): string | null => {
  const t = (s ?? '').trim();
  return t ? t : null;
};

/** A note copied onto a partner's share of a split: the split's own note, cut to fit a purchase note. */
export const noteFromSplit = (splitNote: string | null | undefined): string | null => {
  const t = cleanNote(splitNote);
  return t ? cleanNote(t.slice(0, NOTE_MAX)) : null;
};

/** Activity search: the merchant as shown, the bank text, or the note (case insensitive). */
export const matchesSearch = (q: string, t: { merchant: string; bankText?: string; note?: string | null }): boolean => {
  const s = q.trim().toLowerCase();
  if (!s) return true;
  return [t.merchant, t.bankText ?? '', t.note ?? ''].some((x) => x.toLowerCase().includes(s));
};

/**
 * The note a split request carries: the purchase's "What was this for?" as the person sees it
 * when the split is sent, trimmed and cut to fit ('' is none). There is no separate split note.
 * A re-send after a new total uses the original request's note instead (web/src/new-split.ts).
 */
export const splitNoteOf = (purchaseNote: string | null | undefined): string => cleanNote(cleanNote(purchaseNote)?.slice(0, NOTE_MAX)) ?? '';

/** Under the Accept sheet's "What was this for?" when the request came with a note. */
export const NOTE_FROM_PARTNER = (partner: string) => `From ${partner}, edit if you like.`;

/** Under "What was this for?" while a split is about to be sent with that note. */
export const NOTE_PARTNER_SEES = (partner: string) => `${partner} will see this.`;
